/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { AppError } from "../../error";

/**
 * Domain error for playback failures.
 * Extends AppError with a display-friendly title.
 */
export class PlaybackError extends AppError {
  public constructor(
    code: string,
    message: string = "",
    title: string = "",
    description: string = ""
  ) {
    // AppError owns `title`/`description` (and `getTitle()`); passing them
    // through keeps a single storage location for both.
    super(code, message, "", title, description);
  }

  /**
   * Set the display title for this error.
   * @param title - The title string.
   */
  public setTitle(title: string): void {
    this.title = title;
  }
}
